export interface CompetenceHistory {
  id: string
  personId: number
  companyCompetenceId: number
  name: string
  description?: string
  companyName: string
  companyId: number
  acquired: string
  updated: string
  revoked?: string
  expired: boolean
  companyCompetenceRemoved: boolean
  files?: CompetenceHistoryFile[]
}

export interface CompetenceHistoryFile {
  id: string
  competenceHistoryId: string
  fileInfoId: number
}

export enum BankIdOrderType {
  Sign = 'sign',
  Auth = 'auth'
}

export interface BankIdStatus {
  orderRef: string
  type: string
  status: string
  hintCode: string
  message: string
  qrCode?: string
  socialSecurityNumber?: string
  firstname?: string
  lastname?: string
}
